module.exports = __webpack_public_path__ + "static/media/redcorss.87c3adb8.png";